<div class="login-box">
  <div *ngIf="isLoading$ | async" class="loading-overlay">
    <p-progressSpinner></p-progressSpinner>
    <p>Validando token...</p>
  </div>

  <div *ngIf="!(isLoading$ | async)">
    <mat-icon class="user-icon">lock</mat-icon>

    <h1 class="login-heading">Restablecer contraseña</h1>

    <form
      [formGroup]="resetPasswordForm"
      class="login-form"
      (ngSubmit)="onSubmit()"
    >
      <mat-form-field appearance="outline" class="input-field">
        <mat-label>Contraseña</mat-label>
        <input
          matInput
          [type]="hidePassword ? 'password' : 'text'"
          id="password"
          formControlName="password"
          placeholder="Ingrese su contraseña"
        />
        <button
          mat-icon-button
          matSuffix
          (click)="hidePassword = !hidePassword"
          type="button"
        >
          <mat-icon>{{
            hidePassword ? "visibility" : "visibility_off"
          }}</mat-icon>
        </button>

        <mat-error *ngIf="resetPasswordForm.get('password')?.invalid">
          <ul class="error-list">
            <li *ngIf="resetPasswordForm.get('password')?.hasError('required')">La contraseña es requerida</li>
            <li *ngIf="resetPasswordForm.get('password')?.hasError('minlength')">
              Mínimo {{resetPasswordForm.get('password')?.errors?.['minlength'].requiredLength}} caracteres
            </li>
            <li *ngIf="resetPasswordForm.get('password')?.hasError('pattern')">
              Debe contener letras y números, sin caracteres especiales
            </li>
          </ul>
        </mat-error>
      </mat-form-field>

      <button
        mat-raised-button
        style="background-color: #ffa600; color: white; padding: 0.5rem 1rem"
        class="submit-button"
        [disabled]="resetPasswordForm.invalid || isSubmitting"
        [ngClass]="{ disabled: resetPasswordForm.invalid || isSubmitting }"
      >
        <ng-container *ngIf="isLoading$ | async">
          <span class="indicator-progress">
            Por favor espere...
            <p-progressSpinner
              [style]="{
                width: '1.5rem',
                height: '1.5rem',
                padding: '0.5rem 1rem'
              }"
              animationDuration="1.5s"
              aria-label="Cargando"
            ></p-progressSpinner>
          </span>
        </ng-container>
        <ng-container *ngIf="!(isLoading$ | async)">
          <span class="indicator-label">Restablecer contraseña</span>
        </ng-container>
      </button>
    </form>
  </div>
</div>
